import * as React from 'react'
import { WebAdminUser } from '../api'

type StringBuilderForCurrentSession = (user: WebAdminUser | null) => string

export enum PageType {
  Support = 0,
  Agency = 1,
  Nested = 2,
  Admin = 3
}

export interface PageDefinition {
  routes: (user: WebAdminUser | null) => string[]
  routeBack?(user: WebAdminUser | null): string
  component: React.ReactNode
  navLinkText?: string
  pageTitle: string | StringBuilderForCurrentSession
  canAccess: (user: WebAdminUser | null) => boolean
  buildNavLink: StringBuilderForCurrentSession
  type: PageType[]
  groupName?: string
  sortOrder: (type: PageType) => number
}
